import { render, staticRenderFns } from "./transition-detail.vue?vue&type=template&id=5fa19305"
import script from "./transition-detail.ts?vue&type=script&lang=ts&external"
export * from "./transition-detail.ts?vue&type=script&lang=ts&external"
import style0 from "./transition-detail.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports